import {
  getChatGetChatByIdQueryKey,
  getChatGetChatsQueryKey,
  getChatGetFeedPostsForUserQueryKey,
} from "@/orval/gen"
import { usePostMutation } from "@/typed-client/hooks/use-post-mutation"
import { showErrorNotification } from "@/utils/form-submission-notifications"
import { ActionIcon, ActionIconProps } from "@mantine/core"
import { IconStar, IconStarFilled } from "@tabler/icons-react"
import { useQueryClient } from "@tanstack/react-query"
import { MouseEventHandler } from "react"

interface Props
  extends Omit<ActionIconProps, "children" | "variant" | "onClick"> {
  subscribed: boolean
  id: number
}

export function FeedSubscribeIcon({ subscribed, id, ...props }: Props) {
  const queryClient = useQueryClient()
  const invalidateQueries = React.useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: getChatGetChatByIdQueryKey({ chatId: id }),
    })
    queryClient.invalidateQueries({
      queryKey: getChatGetChatsQueryKey(),
    })
    queryClient.invalidateQueries({
      queryKey: getChatGetFeedPostsForUserQueryKey(),
    })
  }, [queryClient])
  const { mutateAsync: toggleSubscribe } = usePostMutation(
    "/api/Chat/ToggleSubscribeFeed",
    {
      onError: showErrorNotification,
      onSuccess: () => {
        invalidateQueries()
      },
    }
  )

  const handleSubscribe: MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    await toggleSubscribe({ id })
  }
  return (
    <ActionIcon variant="subtle" onClick={handleSubscribe} {...props}>
      {subscribed ? <IconStarFilled /> : <IconStar />}
    </ActionIcon>
  )
}
